/* eslint-disable no-unused-vars, eqeqeq */
import { useState, Fragment, useRef, useEffect } from "react";
import Box from "@mui/material/Box";
import TextField from "@mui/material/TextField";
import PersonIcon from "@mui/icons-material/Person";
import Button from "@mui/material/Button";
import Snackbar from "@mui/material/Snackbar";
import CloseIcon from "@mui/icons-material/Close";
import IconButton from "@mui/material/IconButton";
import Typography from "@mui/material/Typography";
import Link from "@mui/material/Link";
import { useNavigate } from "react-router-dom";

import { getLogonToken, resetPassword } from "../service/service_handler";
import fluortronixLogo from "../logo/fluortronix-final.png";

const loginOutlinedFieldSx = {
  maxWidth: 360,
  "& .MuiInputLabel-root": {
    fontSize: "1.0125rem",
    fontWeight: 400,
    color: "text.secondary",
    "&.Mui-focused": {
      color: "primary.main",
    },
    "&.MuiInputLabel-shrink": {
      fontSize: "0.95625rem",
      fontWeight: 400,
    },
  },
  "& .MuiOutlinedInput-input": {
    fontSize: "1.125rem",
    fontWeight: 400,
    lineHeight: 1.5,
    color: "text.primary",
    fontFamily: "inherit",
  },
};

const loginPasswordFieldSx = {
  ...loginOutlinedFieldSx,
  "& .MuiInputLabel-root": {
    ...loginOutlinedFieldSx["& .MuiInputLabel-root"],
    color: "primary.main",
    "&.Mui-focused": {
      color: "primary.dark",
    },
  },
  "& .MuiOutlinedInput-input": {
    ...loginOutlinedFieldSx["& .MuiOutlinedInput-input"],
    color: "primary.main",
  },
  "& .MuiOutlinedInput-input:-webkit-autofill": {
    WebkitBoxShadow: "0 0 0 1000px #EAEAEA inset",
    WebkitTextFillColor: "#1f458D",
  },
};

export default function Login() {
  const [userName, setUserName] = useState("");
  const [passwordTest, setPasswordText] = useState("");
  const [passwordCnfTest, setPasswordCnfText] = useState("");
  const [openSnack, setOpenSnack] = useState(false);
  const [openSnackErrMsg, setopenSnackErrMsg] = useState("");
  const [noData, setNoData] = useState(false);
  const [showReset, setShowReset] = useState(false);
  const [email, setEmail] = useState("");
  const navigate = useNavigate();
  const cardRef = useRef(null);
  const [dividerHeight, setDividerHeight] = useState(270);

  useEffect(() => {
    const el = cardRef.current;
    if (!el) {
      return undefined;
    }
    const update = () => {
      setDividerHeight(el.offsetHeight);
    };
    update();
    const ro = new ResizeObserver(update);
    ro.observe(el);
    return () => ro.disconnect();
  }, [showReset]);

  useEffect(() => {
    if (showReset) return undefined;

    let listenersAttached = false;
    const readAndSync = () => {
      const elUser = document.getElementById("login-username");
      const elPass = document.getElementById("login-password");
      if (!elUser || !elPass) return;
      setUserName((prev) => (elUser.value !== prev ? elUser.value : prev));
      setPasswordText((prev) => (elPass.value !== prev ? elPass.value : prev));
      if (!listenersAttached) {
        listenersAttached = true;
        elUser.addEventListener("input", readAndSync);
        elPass.addEventListener("input", readAndSync);
        elUser.addEventListener("change", readAndSync);
        elPass.addEventListener("change", readAndSync);
      }
    };

    const timers = [0, 50, 120, 250, 500, 1000, 2000].map((ms) =>
      setTimeout(readAndSync, ms)
    );

    return () => {
      timers.forEach(clearTimeout);
      const elUser = document.getElementById("login-username");
      const elPass = document.getElementById("login-password");
      if (listenersAttached && elUser && elPass) {
        elUser.removeEventListener("input", readAndSync);
        elPass.removeEventListener("input", readAndSync);
        elUser.removeEventListener("change", readAndSync);
        elPass.removeEventListener("change", readAndSync);
      }
    };
  }, [showReset]);

  const handleUserName = (event) => {
    setUserName(event.target.value);
  };

  const handleEmail = (event) => {
    setEmail(event.target.value);
  };

  const handlePasswordText = (event) => {
    setPasswordText(event.target.value);
  };

  const handlePasswordCnfText = (event) => {
    setPasswordCnfText(event.target.value);
  };

  const handleCloseSnack = (event, reason) => {
    if (reason === "clickaway") {
      return;
    }

    setOpenSnack(false);
  };

  const handleLogin = (event) => {
    // let history = useHistory()
    const login_data = {
      userName: userName,
      userPassword: passwordTest,
    };
    if (userName != "" && passwordTest != "") {
      getLogonToken(login_data)
        .then(function (response) {
          // setopenSnackErrMsg("Successfully Added device " + response.data.code);
          // setOpenSnack(true);
          localStorage.setItem("token", response.data.token);
          console.log(localStorage.getItem("token"));
          // this.props.history.push("/dashboard");
          // return <Redirect to="/dashboard" />;
          navigate("/dashboard");
        })
        .catch((error) => {
          console.log("service-error", error);
          if (!error.response) {
            setopenSnackErrMsg("Network error please try again");
            setOpenSnack(true);
            setNoData(true);
          } else {
            setopenSnackErrMsg(error.response.data.msg);
            setOpenSnack(true);
            setNoData(true);
          }
        });
    } else {
      setopenSnackErrMsg("Please enter valid Data!");
      setOpenSnack(true);
    }
  };

  const handleResetPassword = (event) => {
    const reset_data = {
      userName: userName,
      email: email,
    };
    if (userName != "" && email != "") {
      resetPassword(reset_data)
        .then(function (response) {
          setopenSnackErrMsg("Success - " + response.data.message);
          setOpenSnack(true);
          setTimeout(() => {
            setEmail("");
            setShowReset(false);
          }, 1000);
        })
        .catch((error) => {
          console.log("service-error", error);
          if (!error.response) {
            setopenSnackErrMsg("Network error please try again");
            setOpenSnack(true);
            setNoData(true);
          } else {
            setopenSnackErrMsg(error.response.data.msg);
            setOpenSnack(true);
            setNoData(true);
          }
        });
    } else {
      setopenSnackErrMsg("Please enter valid UserName/Email");
      setOpenSnack(true);
    }
  };

  const handleShowReset = (event) => {
    setShowReset(!showReset);
  };

  const snackAction = (
    <Fragment>
      {/* <Button color="secondary" size="small" onClick={handleCloseSnack}>
        UNDO
      </Button> */}
      <IconButton
        size="small"
        aria-label="close"
        color="inherit"
        onClick={handleCloseSnack}
      >
        <CloseIcon fontSize="small" />
      </IconButton>
    </Fragment>
  );

  return (
    <Box
      sx={{
        position: "relative",
        minHeight: "100vh",
        width: "100%",
        display: "flex",
        flexDirection: { xs: "column", sm: "row" },
        boxSizing: "border-box",
      }}
    >
      <Box
        component="img"
        src={fluortronixLogo}
        alt="Fluortronix"
        sx={{
          position: "absolute",
          top: { xs: 16, sm: 24 },
          left: { xs: 16, sm: 24 },
          zIndex: 1,
          height: { xs: 40, sm: 48 },
          width: "auto",
          maxWidth: { xs: "min(70vw, 260px)", sm: 320 },
          objectFit: "contain",
        }}
      />
      <Snackbar
        open={openSnack}
        autoHideDuration={2000}
        onClose={handleCloseSnack}
        message={openSnackErrMsg}
        action={snackAction}
      />

      <Box
        aria-hidden
        sx={{
          display: { xs: "none", sm: "block" },
          position: "absolute",
          left: "50%",
          top: "50%",
          zIndex: 0,
          transform: "translate(-50%, -50%)",
          width: 2,
          height: dividerHeight,
          bgcolor: "primary.main",
          borderRadius: 0.5,
          pointerEvents: "none",
        }}
      />

      <Box
        sx={{
          display: { xs: "none", sm: "flex" },
          flex: "0 0 50%",
          minHeight: "100vh",
          boxSizing: "border-box",
          alignItems: "center",
          justifyContent: "center",
          px: 3,
        }}
      >
        <Typography
          variant="h4"
          component="h1"
          sx={(theme) => ({
            textAlign: "center",
            fontWeight: 600,
            color: "primary.main",
            letterSpacing: "-0.02em",
            lineHeight: 1.25,
            fontSize: `calc(${theme.typography.h4.fontSize} * 0.9)`,
          })}
        >
          IOT Dashboard Login
        </Typography>
      </Box>

      <Box
        sx={{
          width: { xs: "100%", sm: "50%" },
          minHeight: "100vh",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          flex: { xs: "1 1 auto", sm: "0 0 50%" },
          boxSizing: "border-box",
          p: 2,
        }}
      >
        {!showReset && (
          <Box
            ref={cardRef}
            display="flex"
            justifyContent="center"
            alignItems="center"
            flexDirection="column"
            minHeight={270}
            borderRadius={3}
            boxShadow={5}
            width="100%"
            maxWidth={360}
            bgcolor="#EAEAEA"
            sx={{ p: 1.8, boxSizing: "border-box" }}
          >
            <PersonIcon sx={{ fontSize: { xs: 36, sm: 43.2 } }} />
            <TextField
              autoFocus
              margin="normal"
              id="login-username"
              name="username"
              label="User Name"
              type="text"
              fullWidth
              sx={{ mt: 2, ...loginOutlinedFieldSx }}
              value={userName}
              onChange={handleUserName}
              variant="outlined"
              InputLabelProps={{ shrink: true }}
              inputProps={{
                autoComplete: "username",
              }}
            />
            <TextField
              margin="normal"
              id="login-password"
              name="password"
              label="Password"
              type="password"
              fullWidth
              sx={{ mt: 1, ...loginPasswordFieldSx }}
              value={passwordTest}
              onChange={handlePasswordText}
              variant="outlined"
              InputLabelProps={{ shrink: true }}
              inputProps={{
                autoComplete: "current-password",
              }}
            />
            <Button size="medium" onClick={handleShowReset} sx={{ mt: 1 }}>
              Forgot Password
            </Button>
            <Button
              variant="contained"
              size="medium"
              fullWidth
              sx={{ mt: 2, maxWidth: 360 }}
              onClick={handleLogin}
            >
              LOGIN
            </Button>
          </Box>
        )}
        {showReset && (
          <Box
            ref={cardRef}
            display="flex"
            justifyContent="center"
            alignItems="center"
            flexDirection="column"
            minHeight={270}
            borderRadius={3}
            boxShadow={5}
            width="100%"
            maxWidth={360}
            bgcolor="#EAEAEA"
            sx={{ p: 1.8, boxSizing: "border-box" }}
          >
            <PersonIcon sx={{ fontSize: { xs: 36, sm: 43.2 } }} />
            <Typography variant="subtitle2" sx={{ mt: 1, textAlign: "center" }}>
              New password will be sent to your registred email.
            </Typography>
            <TextField
              autoFocus
              margin="dense"
              size="small"
              id="reset-username"
              name="username"
              label="User Name"
              type="text"
              fullWidth
              sx={{ mt: 2, maxWidth: 320 }}
              value={userName}
              onChange={handleUserName}
              variant="outlined"
              InputLabelProps={{ shrink: true }}
              inputProps={{ autoComplete: "username" }}
            />
            <TextField
              margin="dense"
              size="small"
              id="reset-email"
              name="email"
              label="Registred Email"
              type="email"
              fullWidth
              sx={{ mt: 1, maxWidth: 320 }}
              value={email}
              onChange={handleEmail}
              variant="outlined"
              InputLabelProps={{ shrink: true }}
              inputProps={{ autoComplete: "email" }}
            />
            <Button
              variant="contained"
              size="medium"
              fullWidth
              sx={{ mt: 2, maxWidth: 320 }}
              onClick={handleResetPassword}
            >
              RESET
            </Button>
          </Box>
        )}
      </Box>

      <Link
        href="https://www.fluortronix.com"
        target="_blank"
        rel="noopener noreferrer"
        underline="hover"
        sx={{
          position: "absolute",
          bottom: { xs: 16, sm: 24 },
          left: "50%",
          transform: "translateX(-50%)",
          zIndex: 1,
          typography: "body2",
        }}
      >
        www.fluortronix.com
      </Link>
    </Box>
  );
}
